import { useDisplaySettings } from '@src/providers/DisplaySettingsProvider';
import { POSITION } from '@talos/kyoko';
import { useMemo } from 'react';
import { POSITIONS_BLOTTER_CONVERSION_TOLERANCE } from './tokens';

interface UsePositionsBaseRequestParams {
  blotterID: string;
  showZeroBalances: boolean;
}

/**
 * Shared base WebSocket request used by every Positions blotter variant
 * (Spot / Derivatives / Predictions / Sub Accounts / Unified, desktop and mobile).
 * Filters are merged in by the caller — this only covers the fields that are
 * identical across those blotters.
 */
export function usePositionsBaseRequest({ blotterID, showZeroBalances }: UsePositionsBaseRequestParams) {
  const { homeCurrency } = useDisplaySettings();
  return useMemo(
    () => ({
      name: POSITION,
      tag: blotterID,
      ShowZeroBalances: showZeroBalances,
      EquivalentCurrency: homeCurrency,
      Tolerance: POSITIONS_BLOTTER_CONVERSION_TOLERANCE,
    }),
    [blotterID, showZeroBalances, homeCurrency]
  );
}
